import { ToastrManager } from 'ng6-toastr-notifications';
import { Router } from '@angular/router';
import { Component, Injector } from '@angular/core';
import { ServicesService } from 'src/app/pages/servicos/services.service';
import { EncodeData } from 'src/app/shared/models/encode.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { BaseListComponent } from 'src/app/shared/components/base-list-component/base-list-component';
import { Service } from './service.model';
@Component({
  selector: 'app-servicos',
  templateUrl: './servicos.component.html',
  styleUrls: ['./servicos.component.css']
})
export class ServicosComponent extends BaseListComponent<Service>{

  protected initChildMethods(): void {}
  protected initChildProprieties(): void {}

  constructor(
    public servicesServ: ServicesService,
    public injector: Injector,
    public auth:AuthService,
    public toastr: ToastrManager,
  ) {
    super(servicesServ,injector,'service',{createUrl:'/admin/services/new',editUrl:'/admin/services/edit',detailUrl:'/admin/services/detail'});
   }

  protected tableProprieties(): string[] {
    return [
      'Nome',
      'Bónus Khuzela',
      'Bónus Clube',
      'Bónus Sócio',
      'Parceiro'
    ]
  }
}
